import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../auth/AuthContext';
import type { CurrentUser } from '../../auth/AuthContext';
import { CredentialsForm } from './CredentialsForm';
import { OtpForm } from './OtpForm';
import { EnrollmentForm } from './EnrollmentForm';
import { RecoveryCodesScreen } from './RecoveryCodesScreen';

type Step =
  | { name: 'credentials' }
  | { name: 'otp'; challengeToken: string }
  | { name: 'enroll'; challengeToken: string }
  | { name: 'recovery'; codes: string[]; user: CurrentUser };

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState<Step>({ name: 'credentials' });

  function enter(user: CurrentUser) {
    navigate(user.allow_password_change ? '/change-password' : '/', { replace: true });
  }

  async function onCredentials(email: string, password: string) {
    const result = await login(email, password);
    if (result.kind === 'authenticated') enter(result.user);
    else if (result.kind === 'otp_required') setStep({ name: 'otp', challengeToken: result.challengeToken });
    else setStep({ name: 'enroll', challengeToken: result.challengeToken });
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-4">
      {step.name === 'credentials' && <CredentialsForm onSubmit={onCredentials} />}
      {step.name === 'otp' && (
        <OtpForm challengeToken={step.challengeToken} onSuccess={enter} />
      )}
      {step.name === 'enroll' && (
        <EnrollmentForm
          challengeToken={step.challengeToken}
          onEnrolled={(codes, user) => setStep({ name: 'recovery', codes, user })}
        />
      )}
      {step.name === 'recovery' && (
        <RecoveryCodesScreen codes={step.codes} onDone={() => enter(step.user)} />
      )}
    </main>
  );
}
